import React from 'react'

export default function SplitViewMainContent({ children, ...other }) {
    return (
        <div className={'ui-sv-content-main'} {...other}>
            {children}
        </div>
    )
}
